export default {
  props: {
    width: {
      required: false,
      type: [Number, String],
      default: 18
    },

    height: {
      required: false,
      type: [Number, String],
      default: 18
    },

    viewBox: {
      required: false,
      type: String,
      default: '0 0 100 100'
    },

    iconColor: {
      required: false,
      type: String,
      default: 'currentColor'
    },

    disabled: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      disabledStateColor: '#B9B9B9'
    }
  }
}
